import { memo } from "react";

// Helpers
import { classNames } from "helpers";

// UI
import Badge from "ui/components/Badge/Badge";
import { BadgeProps } from "ui/components/Badge/types";
import TableIcon from "ui/components/Table/TableSearch/components/TableIcon";
import { TableRowChildProps } from "ui/components/Table/TableSearch/types";

const STATUS_DOT_COLORS: Record<string, string> = {
  orange: "bg-orange-500",
  blue: "bg-blue-500",
  green: "bg-green-500",
  slate: "bg-slate-500",
};

const STATUS_BADGE_VARIANT: Record<string, BadgeProps["variant"]> = {
  orange: "warning",
  blue: "info",
  green: "success",
  slate: "secondary",
};

/**
 * Jedna oznaka štete u razlaganju retka: fotografija na kojoj je označena,
 * naziv s točkom u boji statusa, opis i status.
 */
const DamagePinRowChild: React.FC<TableRowChildProps> = ({ index, row }) => {
  const color = row.vehicleDamageStatusColor ?? "orange";

  return (
    <tr
      className={classNames(index % 2 === 0 ? "bg-white" : "bg-slate-50")}
    >
      <td className="px-4 py-2 text-sm text-slate-600">
        <TableIcon
          imageUrl={row.uploadUrl}
          icon="/media/icons/picture.svg"
          size="small"
          imageFit="cover"
          showThumbnail={!!row.uploadUrl}
        />
      </td>
      <td className="px-4 py-2 text-sm text-slate-600">
        <div className="flex items-center gap-2">
          <span
            className={classNames(
              "w-3 h-3 rounded-full flex-shrink-0",
              STATUS_DOT_COLORS[color] ?? "bg-orange-500"
            )}
          />
          <span className="font-medium text-slate-900">
            {row.name || "Bez naziva"}
          </span>
        </div>
      </td>
      <td className="px-4 py-2 text-sm text-slate-500">
        <div className="max-w-[420px] truncate">{row.description || "-"}</div>
      </td>
      <td className="px-4 py-2 text-sm text-slate-500">
        {row.vehicleDamageStatusName && (
          <Badge
            text={row.vehicleDamageStatusName}
            variant={STATUS_BADGE_VARIANT[color] ?? "info"}
            height="small"
            showDot
          />
        )}
      </td>
    </tr>
  );
};

export default memo(DamagePinRowChild);
